module.exports = __webpack_public_path__ + "static/img/googleplay.c87bef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/googleplay.png
// module id = btj1
// module chunks = 1